import { BasketItemModel, BasketPriceModel, BasketSessionModel, DeliveryModeModel, BasketUserModel } from 'models/Basket';
import { Type } from 'class-transformer';
import { BasketAddressModel } from './BasketAddressModel';
import { ProductTypes } from './ProductTypes';

export class BasketDetailsModel {
    public code: string;

    public guid: string;

    @Type(() => BasketItemModel)
    public entries: BasketItemModel[] = [];

    @Type(() => BasketPriceModel)
    public totalPriceWithTax: BasketPriceModel;

    @Type(() => BasketPriceModel)
    public totalDiscounts: BasketPriceModel;

    @Type(() => BasketPriceModel)
    public deliveryCost: BasketPriceModel | null = null;

    @Type(() => DeliveryModeModel)
    public deliveryMode: DeliveryModeModel | null = null;

    @Type(() => BasketAddressModel)
    public deliveryAddress: BasketAddressModel | null = null;

    @Type(() => BasketAddressModel)
    public paymentAddress: BasketAddressModel | null = null;

    public leadTime: number;

    public eca: number | null = null;

    public deliveryItemsQuantity: number;

    public totalItems: number;

    @Type(() => BasketSessionModel)
    public session: BasketSessionModel;

    @Type(() => BasketUserModel)
    public user: BasketUserModel;

    private totalUnitCount: number;

    public get totalBasketItemsCount(): number {
        if (!this.entries) {
            return this.totalUnitCount;
        }

        return this.totalUnitCount - this.entries.reduce((result: number, item: BasketItemModel) => {
            if (item?.product?.type === ProductTypes.Sofaglide) {
                return item.quantity + result;
            }

            return result;
        }, 0);
    }

    public hasDeliverableProducts(): boolean {
        return this.entries.some(p => !p.deliveryPointOfService);
    }

    public hasDonationProduct(): boolean {
        return this.entries.some((basketItem: BasketItemModel) => basketItem.product.type === ProductTypes.Donation);
    }

    public isEmpty(): boolean {
        return this.entries.length === 0;
    }

    public hasSofashields(): boolean {
        return this.entries.some((basketItem: BasketItemModel) => basketItem.sofashieldQuantity > 0);
    }

    public isCurrentPostcodeEire(): boolean {
        return this.deliveryAddress?.postcode.isEirCode ?? false;
    }

    public isCurrentPostcodeNorthernIreland(): boolean {
        return this.deliveryAddress?.postcode.isNorthernIrelandPostcode ?? false;
    }

    public getWarrantyAmount(): number {
        return this.entries
            .filter(e => e.product.type === ProductTypes.Sofashield)
            .sum(e => e.totalPrice.value);
    }

    public hasDwellProducts(): boolean {
        return this.entries.some((basketItem: BasketItemModel) => basketItem.isDwell());
    }

    public isDwellMixedBasket(): boolean {
        return this.hasDwellProducts() && Boolean(this.entries.some((basketItem: BasketItemModel) =>
            !basketItem.isDwell() && basketItem.product.type !== ProductTypes.Donation));
    }

    public hasQuickstockItem(): boolean {
        return this.entries.some((basketItem: BasketItemModel) => basketItem.isQuickstock());
    }
}